import ReceiptTemplate from './ReceiptTemplate';
export default ReceiptTemplate;
